import type { PropsWithChildren, ReactNode } from "react";
import { Typography } from "antd";

const { Text, Title } = Typography;

type GlassPanelProps = PropsWithChildren<{
  eyebrow?: string;
  title?: string;
  actions?: ReactNode;
  className?: string;
  bodyClassName?: string;
}>;

export default function GlassPanel({
  eyebrow,
  title,
  actions,
  className = "",
  bodyClassName = "",
  children,
}: GlassPanelProps) {
  return (
    <section className={`overflow-hidden rounded-lg border border-black/8 bg-white shadow-xs dark:border-white/8 dark:bg-[#061417] ${className}`}>
      {(eyebrow || title || actions) && (
        <div className="flex flex-wrap items-start justify-between gap-3 border-b border-black/8 px-5 py-4 dark:border-white/8">
          <div className="min-w-0">
            {eyebrow ? (
              <Text className="block text-[11px]! uppercase tracking-[0.2em] text-black/45 dark:text-white/45">
                {eyebrow}
              </Text>
            ) : null}
            {title ? <Title level={5} className="mb-0! mt-2!">{title}</Title> : null}
          </div>
          {actions}
        </div>
      )}
      <div className={`p-5 ${bodyClassName}`}>{children}</div>
    </section>
  );
}
